import React from 'react';
import Ewaste2025  from 'views/Ewaste2025';


const ClassAssembly11CPage = () => {
    return <Ewaste2025 />;
  };
  
  export default ClassAssembly11CPage;

  